module.exports = __webpack_public_path__ + "static/media/appointment_4.22ffbd15.jpeg";